module.exports = __webpack_public_path__ + "img/fin-academy-e-learning.dcaeeefe.svg";